import styled from 'styled-components';

import colors from '@front/common/src/utils/colors';
import { formatPrice, formatPricePerHour } from '@front/common/src/utils/formatting';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import type { WithClassNameProps } from '@front/web-ui/src/components/types';

const PromoLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHighlightText = styled(Text.MDBold)`
  margin-left: 5px;
`;

type ReductionLineProps = WithClassNameProps & {
  title: string;
  value: number;
  shouldFormatPricePerHour?: boolean;
  label?: string;
};

const ReductionLine = ({ title, value, className, shouldFormatPricePerHour = false, label }: ReductionLineProps) => {
  const reduction = shouldFormatPricePerHour ? formatPricePerHour(value) : formatPrice(value);

  return (
    <div className={className}>
      <PromoLine>
        <TitleWrapper>
          <Text>{title}</Text>
          {!!label && <StyledHighlightText color={colors.pink120}>{label}</StyledHighlightText>}
        </TitleWrapper>
        {label ? (
          <Text.SMBold color={colors.pink120}>{`-${reduction}`}</Text.SMBold>
        ) : (
          <Text.SM color={colors.ink50}>{`-${reduction}`}</Text.SM>
        )}
      </PromoLine>
    </div>
  );
};

export default ReductionLine;
